import * as types from './constants';

const initialState = {
  data: {},
  sendLoading: false,
  errors_api: {}
};

const actions = {
  // Invite Member
  [types.INVITE_MEMBER_REQUEST]: state => {
    const data = {
      ...state,
      sendLoading: true
    };

    return { ...data };
  },

  [types.INVITE_MEMBER_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      sendLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.INVITE_MEMBER_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      sendLoading: false,
      errors_api: payload
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};